import { render, staticRenderFns } from "./EditLog.vue?vue&type=template&id=36652006&scoped=true&"
import script from "./EditLog.vue?vue&type=script&lang=js&"
export * from "./EditLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36652006",
  null
  
)

export default component.exports